export const getVariantFromStatus = status => {
  const map = {
    Pending: 'warning',
    Active: 'info',
    Closed: 'success',
    Cancelled: 'danger',
    'New Order': 'success',
    'Due Diligence': 'info',
    'Information Requested': 'info',
    'Preliminary Report': 'info',
    'Information Received': 'warning',
    'Ready for QA': 'warning',
    'Revision': 'warning',
    'Pending To Pay': 'secondary',
    Paid: 'dark'
  };

  return map[status] || 'primary';
};

export const getBgColorFromStatus = status => {
  const map = {
    'Information Requested': { bg: '#FEC416', text: '#FFFFFF' },
    'Preliminary Report': { bg: '#7C6AE8', text: '#FFFFFF' },
    'New Order': { bg: '#A6A6A6', text: '#FFFFFF' },
    'Due Diligence': { bg: '#14B8A6', text: '#FFFFFF' },
    Update: { bg: '#FD8118', text: '#FFFFFF' },
    'Information Received': { bg: '#9DC12B', text: '#FFFFFF' },
    'Ready for QA': { bg: '#4DA3FF', text: '#FFFFFF' },
    'Revision': { bg: '#FFB020', text: '#FFFFFF' },
    Hold: { bg: '#7F3c8A', text: '#FFFFFF' },
    'On Hold': { bg: '#ffedd5', text: '#78350F' },
    'Link Sent': { bg: '#545454', text: '#FFFFFF' },
    Pending: { bg: '#B7A38A', text: '#FFFFFF' },
    'Pending To Pay': { bg: '#4DCDC5', text: '#FFFFFF' },
    Paid: { bg: '#00C875', text: '#FFFFFF' },
    Cancelled: { bg: '#BA3353', text: '#FFFFFF' },
    'Cancellation Requested': { bg: '#FB923C', text: '#FFFFFF' },
    'In Progress': { bg: '#FFFBEB', text: '#78350F' },
    Refunded: { bg: '#FFADAD', text: '#FFFFFF' },
    'Update In Progress': { bg: '#FFFBEB', text: '#78350F' },
    'Completed/Unpaid': { bg: '#ECFDF5', text: '#065F46' },
    'Completed/Paid': { bg: '#ECFDF5', text: '#065F46' },
    'Refund Requested': { bg: '#FF7575', text: '#FFFFFF' },
  };

  return map[status] || { bg: '#F9FAFB', text: '#374151' }; // default gray-50 / gray-700
};

export const onScrollToErrorPosition = id => {
  setTimeout(() => {
    const field = document.getElementById(id);
    if (field) field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 200);
};
